{
    "ConsidermovedtounresolvedasoverflowedLabel": "Considérer les appels déplacés vers des dispositifs non résolus comme débordés :",
    "StatisticCalculations_SectionHeader": "Calculs statistiques",
    "StatisticCalculations_SectionPara": "Vous pouvez choisir si les appels sont considérés comme débordés ou abandonnés lorsque l'application délibérément ",
    "NAME": "StatisticCalculations"
}